import { useContext } from 'react'; 
import { useNavigate } from 'react-router-dom';
import { UserContext } from './../hooks/UserContext';
export default function useLogout() {
    const navigate = useNavigate();
    const {setUser} = useContext(UserContext);
    const logoutUser = async () => {
        try {
            setUser(null);  
            localStorage.removeItem('token');
            navigate('/login');
        } catch(err) {
            console.log(err);
        } 
    }

    return {
        logoutUser
    }

}
